import { render } from "./PreferredState.vue?vue&type=template&id=5c5e5218&scoped=true"
import script from "./PreferredState.vue?vue&type=script&lang=js"
export * from "./PreferredState.vue?vue&type=script&lang=js"

import "./PreferredState.vue?vue&type=style&index=0&id=5c5e5218&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5e5218"]])

export default __exports__